import { schema } from 'normalizr'

const takeoutReceipt = new schema.Entity('takeoutReceipts')

export default takeoutReceipt
